import { ROUTES } from "const";
import { learningService } from "libs/api";

export class ABILITAZIONE60CFU {

  static async getDashboardCards(courseCode, registrationCode) {

    let cards = [];

    // verify if the course has a public bando
    learningService.bandoIsApproved(registrationCode)
      .then(({ data }) => {

        const { isApproved } = data.payload;
        if (isApproved) {
          cards.push({
            title: "Consulta la graduatoria",
            link: ROUTES.ABILITAZIONE3060_ENROLLMENT_RESULT,
            img: "/img/icon/message.png",
            className: "image-box",
          })
        }

      })
      .catch(error => {

      });

    return cards;
  }

  static getDashboardNotices(courseCode, competitionClass) {

  }
}
